import { FeedbackReply, UserFeedback } from "@/declare/interface/feedback/user-feedback";
import { useContext, useEffect, useRef, useState } from "react";
import { Image, message, Upload } from 'antd';
import dayjs from "dayjs";
import classNames from "classnames";
import { getFeedbackLabelByType, ResponseStatus } from ".";
import localStore from "@/store/local-store";
import './feedback-detail.less'
import { createFeedbackReply, getFeedbackFileUrl, getUserFeedbackDetail, updateUserFeedback } from "@/declare/api/feedback/user-feedback";
import { SOFTWARE_PROJECT_ID, SOFTWARE_PROJECT_NAME } from "@/store/constant";
import UserFeedbackUploadPanel, { UserFeedbackFileUploadParam, UserFeedbacUploadFileLocale } from "./upload-panel";
import Icon, {
    ExclamationCircleOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons'
import { ReactComponent as FaSendSvg } from './icon/fa_send.svg';
import { ReactComponent as FileSvg } from './icon/file.svg';
import TextArea from "antd/es/input/TextArea";
import { UserFeedbackUploadFileContext } from "@/App";
import { emitter, EMITTER_TYPE } from "@/store/mitt";
import ImagePasteListener from "./image-paste-listener";

interface Iprops {
    feedbackId: number
    onUpdateStatus: (newStatus: number) => void
}

const Upload_BUCKET_NAME = "tndas";

interface TnFile {
    fileMd5: string,
    fileSize: number,
    fileSuffix: string,
    filePath: string,
    url: string
}

export default function UserFeedbackDetail(props: Iprops) {

    const { feedbackId } = props;
    const [feedback, setFeedBack] = useState<UserFeedback>(); // 用户反馈信息
    const userName = localStore.name

    const inputValueRef = useRef<string>();

    const [sendLoading, setSendLoading] = useState(false);
    const [inputValue, setInputValue] = useState<string>('');

    const [uploadFileList, setUploadFileList] = useState([]);
    const [file, setFile] = useState<TnFile>(null);
    const fileRef = useRef(file);

    const projectId = SOFTWARE_PROJECT_ID;
    const projectName = SOFTWARE_PROJECT_NAME;

    const uploadFileContext = useContext(UserFeedbackUploadFileContext);

    const feedbackRef = useRef<UserFeedback>();

    useEffect(() => {
        feedbackRef.current = feedback;
    }, [feedback])


    useEffect(() => {
        if (!feedbackId) return;
        getUserFeedbackDetail(feedbackId).then(res => {
            setFeedBack(res.data)
            scrollToBottom();
        })
    }, [feedbackId])

    useEffect(() => {
        inputValueRef.current = inputValue;
    }, [inputValue])

    useEffect(() => {
        fileRef.current = file;
    }, [file])

    useEffect(() => {
        if (!feedbackId) return;
        window.addEventListener('keydown', onKeydown);
        return () => {
            window.removeEventListener('keydown', onKeydown);
        }
    }, [feedbackId])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UserFeedbacUploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    useEffect(() => {
        if (!uploadFileContext.visible) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    const uploadCallbackFn = (uploadFile: UserFeedbackFileUploadParam) => {
        return new Promise(resolve => {
            const file: TnFile = {} as TnFile;
            file.fileMd5 = uploadFile.md5;
            file.fileSize = uploadFile.fileSize;
            file.fileSuffix = uploadFile.suffix;
            file.filePath = uploadFile.filePath;

            getFeedbackFileUrl(file.filePath, Upload_BUCKET_NAME).then(res => {
                if (res.status === 200) {
                    const result = res.data;
                    file.url = result;
                    setFile({ ...file });
                }
            }).finally(() => {
                resolve(true);
            })
        })
    }

    const beforeUpload = (file, fileList) => {
        if (!file.type.includes('image')) {
            message.error('请上传图片');
            return false;
        }
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    // 更新用户反馈的状态
    const onUpdateStatus = (status: number) => {
        updateUserFeedback(feedbackId, { responseStatus: status }).then(res => {
            setFeedBack({ ...feedback, responseStatus: status })
            emitter.emit(EMITTER_TYPE.FEEDBACK_UPDATE)
            props.onUpdateStatus(status)
        })
    }

    const handleImagePaste = (file: File) => {
        if (!feedbackId) return;
        beforeUpload(file, [file]);
    };

    const onKeydown = (e) => {
        let inputValue = inputValueRef.current
        if (e.ctrlKey && e.key === 'Enter') {
            if (inputValue.length <= 0) {
                message.warning('请输入内容');
                return;
            };
            sendFeekbackReply();
        } else if (e.ctrlKey && e.key === 'v') {
            // navigator.clipboard.read()
            //     .then(items => {
            //         items.forEach(item => {
            //             if (item.types.includes('image/png')) {
            //                 item.getType('image/png').then(blob => {
            //                     const file = new File([blob], '图片.png', { type: blob.type });
            //                     beforeUpload(file, [file]);
            //                 }).catch(err => {
            //                     message.error("粘贴图片失败");
            //                 });
            //             }
            //         });
            //     }).catch(err => {
            //         // message.error("获取剪贴板内容失败：" + err)
            //     });
        }
    }


    // 发送回复
    const sendFeekbackReply = () => {
        const name = localStore.name || '未知'
        if (!name) return;
        let inputValue = inputValueRef.current
        if (inputValue === '') {
            message.warning('请输入内容')
            return;
        }
        let dataIn: FeedbackReply = {
            userName: name,
            content: inputValue,
            projectId: projectId,
            projectName: projectName,
            feedbackId: feedbackId
        } as FeedbackReply
        // ctrl enter是事件绑定，拿不到新的文件
        if (fileRef.current != null) {
            dataIn = {
                ...dataIn,
                ...fileRef.current
            }
        }
        setSendLoading(true)
        createFeedbackReply(dataIn).then(res => {
            if (res.status === 200 && res.data) {
                // message.success('发送成功');
                dataIn.id = res.data;
                dataIn.gmtCreate = dayjs().valueOf();
                let replyList = feedbackRef.current.replies || []
                setFeedBack({ ...feedbackRef.current, replies: [...replyList, dataIn] })
                scrollToBottom();
            }
        }).catch((err) => {
            console.log('err', err)
            message.error('发送失败');
        }).finally(() => {
            setInputValue('');
            setFile(null);
            setSendLoading(false);
        })
    }

    const scrollToBottom = () => {
        setTimeout(() => {
            const list = document.getElementById('feedback-reply-list');
            if (list === null || list.children.length === 0) return;
            list.children[list.children.length - 1].scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 200);
    }

    return (
        <div className="user-feedback-detail-container">
            <div className="left-panel">
                <div className="feedback-item">
                    <div className='content'>
                        {feedback?.content}
                    </div>
                    {feedback?.fileMd5 && feedback?.url && <div className='img'>
                        <Image src={feedback?.url} />
                    </div>}
                </div>
                <div className="reply-title">
                    <div className="text">回复</div>
                    <div className="count">{feedback?.replies?.length}</div>
                </div>
                <div className="reply-list" id="feedback-reply-list">
                    {feedback?.replies.map(item => (
                        <div className="reply-item">
                            <div className="user-and-time">
                                <div className="user-name">{item.userName}</div>
                                <div className="time">{dayjs(item.gmtCreate).format('YYYY/MM/DD HH:mm')}</div>
                            </div>
                            <div className="content">
                                <div className="text">{item.content}</div>
                            </div>
                            {item?.fileMd5 && item?.url && <div className='img'>
                                <Image src={item?.url} />
                            </div>}
                        </div>
                    ))}
                </div>
                <div className='feedback-input' style={{ marginRight: '24px' }}>
                    <TextArea
                        readOnly={sendLoading}
                        className='content-input'
                        placeholder='请输入内容 Ctrl+Enter可发送 Ctrl+V上传粘贴板图片(仅可保留一张)'
                        autoSize={{ minRows: 4, maxRows: 4 }}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)} />
                    <div className='ope-area'>
                        {/* <AutoComplete
                    className='keyword-input'
                    placeholder='功能'
                    maxLength={10}
                    options={keywords.filter(item => item.value.match(new RegExp(keywordValue, 'i')))}
                    value={keywordValue}
                    onChange={(value) => setKeywordValue(value)} /> */}
                        <span className='fill-remaining-space'></span>
                        {file && <div style={{ position: 'relative' }}>
                            <Image src={file.url} width={32} height={32} />
                            <CloseCircleOutlined style={{ position: 'absolute', right: '-6px', top: '-6px', color: 'red' }} onClick={() => setFile(null)} />
                        </div>}
                        {!file && <Upload showUploadList={false} beforeUpload={beforeUpload} className="file-upload-wrapper">
                            <FileSvg className='file-upload-icon' />
                        </Upload>}
                        <FaSendSvg onClick={() => {
                            if (inputValue.length <= 0) {
                                message.warning('请输入内容');
                                return;
                            };
                            sendFeekbackReply();
                        }} className={classNames({
                            'send-btn': true,
                            'disabled': inputValue.length <= 0 || sendLoading
                        })} />
                    </div>
                    <UserFeedbackUploadPanel />
                    {/* 注入监听器 */}
                    <ImagePasteListener onImagePaste={handleImagePaste} />
                </div>
            </div>
            <div className="divider"></div>
            <div className="right-panel">
                <div className="info-list">
                    <div className="info-block">
                        <div className="label">提出人</div>
                        <div className="value">{feedback?.userName}</div>
                    </div>
                    <div className="info-block">
                        <div className="label">提出时间</div>
                        <div className="value">{dayjs(feedback?.gmtCreate).format("YYYY/MM/DD HH:mm")}</div>
                    </div>
                    <div className="info-block">
                        <div className="label">状态</div>
                        <div className="value">
                            <div className={classNames({
                                "table-status": true,
                                "table-status-1": feedback?.responseStatus == ResponseStatus.UN_RESPONDED,
                                "table-status-2": feedback?.responseStatus == ResponseStatus.RESPONDED,
                                "table-status-3": feedback?.responseStatus == ResponseStatus.TO_BE_IMPROVED,
                                "table-status-4": feedback?.responseStatus == ResponseStatus.COMPLETED,
                            })}>{getFeedbackLabelByType(feedback?.responseStatus)}
                            </div></div>
                    </div>
                </div>
                {(feedback?.responseStatus == ResponseStatus.UN_RESPONDED || feedback?.responseStatus == ResponseStatus.RESPONDED) && feedback?.userName == userName && (
                    <div className="response-status">
                        <div className="label">问题是否解决</div>
                        <div className={classNames({
                            "status": true,
                            "active": true,
                        })} onClick={() => onUpdateStatus(ResponseStatus.COMPLETED)}>问题已解决</div>
                        <div className={classNames({
                            "status": true,
                        })} onClick={() => onUpdateStatus(ResponseStatus.TO_BE_IMPROVED)}>问题未解决</div>
                    </div>
                )}
            </div>
        </div>
    )
}